import './SelectableIndicatorCard.css';

import React, { useContext } from "react";
import IndicatorCard from "./IndicatorCard";
import { SelectIndicatorContext } from "../../b2b-plans/pages/AreaIndicatorEditPage";
import { generateClassName } from "../../b2b-common/helpers";

const SelectableIndicatorCard = ({ indicator, onSelect, className = null }) => {

    const { selectedIndicator, setSelectedIndicator } = useContext(SelectIndicatorContext);

    const handleSelect = () => {
        setSelectedIndicator(indicator);
        onSelect && onSelect(indicator);
    }

    return (
        <IndicatorCard
            indicator={indicator}
            className={`${generateClassName('selectable-indicator-card', '', className)} ${selectedIndicator && selectedIndicator.indicatorUUID === indicator.indicatorUUID ? 'selected' : ''}`}
            onClick={handleSelect}
        />  
    );
};

export default SelectableIndicatorCard;